enum MallcopAccountEndpoints {
  create = "/mallcop/accounts",
  delete = "/mallcop/accounts/:id",
}

export default MallcopAccountEndpoints;
